import { IZChatState } from "../interfaces";

export const defaultState: IZChatState = {
  typingDisabled: false,
  inQR: false,
  canClickOnIn: true,
  canClickOnOut: true,
};
